const frequency = {
  monthly: "MONTHLY",
  biweekly: "BIWEEKLY",
  weekly: "WEEKLY",
};

export const frequencyTabs = [frequency.monthly, frequency.biweekly, frequency.weekly];

export default frequency;
